import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { ClientError, FailureOperation } from '../../../models/common';
import { FeatureFlagSet } from '../../../models/features';
import {
    applyFeaturesToCurrentLocation,
    disableFeatureFlagsInSet,
    getFeaturesFromCurrentLocation,
} from '../../../utilities/features';
import { trackException } from '../../../utilities/telemetry/channel';
import { replaceCurrentLocation } from '../../../utilities/url';
import { disableFeatures } from '../../actions/features/features-action-creators';
import { DisableFeaturesAction } from '../../actions/features/features-actions';
import { createSagaError } from '../../effects/create-saga-error';
import { takeEvery } from '../../effects/take';
import { getFrozenFeatures } from '../../selector/features-selectors';
import { getPayload } from '../../utilities/payload-action';

export function* disableFeaturesSaga(action: DisableFeaturesAction): SagaIterator {
    const { features } = getPayload(action);

    try {
        const featureFlags: FeatureFlagSet = yield call(getFeaturesFromCurrentLocation);
        const newFeatureFlags: FeatureFlagSet = yield call(disableFeatureFlagsInSet, featureFlags, ...features);
        const frozenFeatures: FeatureFlagSet = yield select(getFrozenFeatures);
        const newUrl: URL = yield call(applyFeaturesToCurrentLocation, newFeatureFlags, frozenFeatures);

        yield call(replaceCurrentLocation, newUrl);
    } catch (err) {
        // No error actions for updating features - we just log the exception
        const error: ClientError = yield createSagaError(err, FailureOperation.DisableFeatures);
        yield call(trackException, error);
    }
}

export function* disableFeaturesListenerSaga(): SagaIterator {
    yield takeEvery(disableFeatures, disableFeaturesSaga);
}
